/* eslint-disable no-loop-func */
/**
 * Helpers
 */
import {pure} from '@react/store'
import {http} from '@helpers/common'
import {DefaultComponentProps} from '@interface/common'


/**
 * Components
 */
import Button from '@components/button'
import SelectOption from '@components/select'

/**
 * Images
 */
import Close from '@assets/images/close.png'



function createComp(item:any) {
  return (
    <div className="user">
      <span className="image">
        {item?.photo ? (
          <img src={item.photo} alt="User avatar"/>
        ):(
          <span className="no-photo">
            <i className="icon-user"/>
          </span>
        )}
      </span>
      <span className="name">
        <strong>{item.name}</strong>
      </span>
    </div>
  )
}


/**
 * Modal content
 */
export default pure(({user, store, modal}: DefaultComponentProps) => {
  const state = store.useLocalState({
    media: null,
    email: null,
    error: null,
    user: user.uid,
    preload: false
  })
  
  function submit() {
    state.set({preload: true})

    http.post('/posts', {
      data: {
        user: {
          uid: user.root?.uid,
          type: user.root?.type
        },
        text: state.text,
        media: state.media,
        type: state.media ? 'media' : 'text',
        file: state.media ? state.media.file : null,
      },
      headers: {
        'Content-Type': 'multipart/form-data;'
      }
    })
    .then(({status, result}) => {
      if(status === 201 || status === 200) {
        modal.close({account: result, preload: false})
      }
    })
    .catch(console.log)
  }


  function getOptions() {
    const opt = []
    for(var item of [user, user.root]) {
      if(item) {
        const name = `${item.firstname} ${item.lastname}`
        opt.push({
          data: item,
          value: name,
          component: createComp({...item, name})
        })
      }
    }
    return opt
  }

  
  const options = getOptions()
  return (
    <div
      id="create-post"
      onClick={(e) => {
        e.stopPropagation()
      }}>
      <div className="head">
        <h2>Create Post</h2>
        <span
          className="close"
          onClick={modal.close}>
          <img alt="Close" src={Close}/>
        </span>
      </div>
      <fieldset className="fields">

        {state.error && (
          <p className="error">{state.error}</p>
        )}

        <div className="field">
          <label>Post as</label>
          <SelectOption
            value={options[0]}
            onChange={(item: any) => {
              state.set({user: item.data.uid})
            }}
            icon={'paper'}
            label={'Select'}
            options={options}
          />
        </div>
        <div className="field">
          <label>Text</label>
          <textarea
            value={state.text}
            onChange={(e) => {
              state.set({text: e.target.value})
            }}
          />
        </div>
        <div className="field media">
          <label>Media</label>
          <label
            htmlFor="file"
            className={'upload'}>
            <input
              id="file"
              type="file"
              accept=".jpeg,.jpg,.png,.mov,.mp4,.gif"
              style={{
                display: 'none'
              }}
              onChange={(e) => {
                const files = e.target.files
                if(files) {
                  const file = files[0]
                  state.set({
                    media: {
                      file,
                      type: file.type.split('/')[0],
                    },
                    file: URL.createObjectURL(file)
                  })
                }
              }}
            />
            {state.file && state.media ? (
              <>
                {state.media.type === 'image' ? (
                  <img alt="" src={state.file}/>
                ):(
                  <video width="320" height="240" controls>
                    <source src={state.file} type="video/mp4"/>
                    <source src={state.file} type="video/ogg"/>
                  </video>
                )}
              </>
              
            ):(
              <span className="select">
                <em>Select</em>
              </span>
            )}
          </label>
          {state.media && (
            <span
              className="remove"
              onClick={() => {
                state.set({media: null})
              }}>
              <i className="icon-close"/>
            </span>
          )}
        </div>
        {/* <div className="field notify">
          <label>Broadcast</label>
          <div className="checkboxes">
            <Checkbox
              space={10}
              onClick={(checked: boolean) => {
                state.set({broadcast: checked})
              }}
              label={'Send notification to followers'}
              checked={state.broadcast}
            />
          </div>
        </div> */}
        <Button
          style={{
            width: '100%',
          }}
          preload={state.preload}
          label={'Publish'}
          onClick={submit}
          className={'button-3'}
        />
      </fieldset>
    </div>
  )
})